<div class="page-content-wrapper">
  <div class="card rounded-3 border-1 shadow">
    <div class="card-header bg-white border-0 me-2">
      <p class="text-s fw-bold">Applications</p>
    </div>
    <div class="card-body">
      <CustomTabs
        :tabs="tabs"
        v-model="currentTab"
      />
      <div class="tab-content">
        <CustomTable
          :columns="columns"
          :fetchData="getApplications"
          :key="currentTab"
          :hasActions="true"
          :tableKey="`client_applications_${currentTab}`"
        >
          <template v-slot:cell-name_email="{ row }">
            {{ row.first_name || row.full_name }} {{ row.last_name || '' }}
            <p class="text-xxs fw-bold">{{ row.email }}</p>
          </template>
          <template v-slot:cell-date_created="{ row }">
            {{ formatDate(row.date_created) }}
          </template>
          <template v-slot:cell-application_status="{ row }">
            <span 
              class="badge rounded-small text-xxs"
              :class="{
                'bg-secondary': row.application_status === 'pending',
                'bg-success': row.application_status === 'approved',
                'bg-danger': row.application_status === 'declined',
                'bg-warning': row.application_status === 'deactivated'
              }">
              {{ row.application_status }}
            </span>
          </template>
          <template v-slot:actions="{ row }">
            <button
              v-if="currentTab === 'Pending'"
              class="btn bg-green btn-sm text-xxs fw-bold rounded-3 shadow"
              @click="view_pending_application(row.user_id)"
            >View</button>
            <button
              v-else-if="currentTab === 'Approved'"
              class="btn bg-green btn-sm text-xxs fw-bold rounded-3 shadow"
              @click="view_approved_application(row.user_id)"
            >View</button>
            <button
              v-else-if="currentTab === 'Deactivated'"
              class="btn bg-green btn-sm text-xxs fw-bold rounded-3 shadow"
              @click="view_deactivated_application(row.user_id)"
            >View</button>
            <button
              v-else-if="currentTab === 'Declined'"
              class="btn bg-green btn-sm text-xxs fw-bold rounded-3 shadow"
              @click="view_declined_application(row.user_id)"
            >View</button>
          </template>
        </CustomTable>
      </div>
    </div>
  </div>
</div>